'use client'

import { useState } from 'react'
import type { TimeRangeKey } from '../../types'
import { getDateFormatter } from '../../utils/dateFormatters'
import { Chart } from './chart/Chart'
import { createChartConfig } from './chart/ChartConfig'
import styles from './ChartWrapper.module.css'
import TimeRangeSelect from './TimeRangeSelect'
import type { ChartType, PriceData } from './types'
import { filterDataByTimeRange } from './utils/filterData'

export function ChartWrapper({ ticker, initialData }: { ticker: string; initialData: PriceData[] }) {
  const [timeRange, setTimeRange] = useState<TimeRangeKey>('1Y')
  const [chartType, setChartType] = useState<ChartType>('area')

  const filteredData = filterDataByTimeRange(initialData, timeRange)
  // const dateFormatter = getDateFormatter(timeRange)

  // Add time unit configuration based on range
  const timeUnit: { unit: 'day' | 'month' | 'year', displayFormat: string } = (() => {
    switch (timeRange) {
      case '1M':
      case '3M':
        return { unit: 'day', displayFormat: 'dd MMM' }
      case '6M':
      case '1Y':
        return { unit: 'month', displayFormat: 'MMM yyyy' }
      case '5Y':
      case 'MAX':
        return { unit: 'year', displayFormat: 'yyyy' }
      default:
        return { unit: 'day', displayFormat: 'dd MMM' }
    }
  })()

  return (
    <div className={styles.chartWrapper}>
      <div className={styles.controlsContainer}>
        {/* <ChartToggle value={chartType} onChange={setChartType} /> */}
        <TimeRangeSelect value={timeRange} onValueChange={setTimeRange} />
      </div>
      <div className={styles.canvasContainer}>
        <Chart
          data={createChartConfig(ticker, filteredData, chartType)}
          type={chartType}
          timeUnit={timeUnit}
        />
      </div>
    </div>
  )
}